<div class="the-list">
  <app-table [clickRow]="clickRow" [type]="type" [tableList]="tableList" [loading]="loading" [listLimit]="listLimit" [list]="list" [potentialRequests]="potentialRequests"
    [selected]="selected" (callbackFunction)="openCandidate.emit($event)" (view)="view.emit($event)"></app-table>
    <div *ngIf="pagination.loading" class="loading"><fa-icon [icon]="faSpinner" [spin]="true"></fa-icon></div>
  <app-load-more *ngIf="listLimit < list.length" [loadMoreLength]="loadMoreLength" (loadMore)="loadMore.emit(loadMoreLength)"></app-load-more>
</div>
